import classNames from 'classnames'

import styles from './styles.module.css'
import { TrustpilotLogo } from './trustpilot-logo'

export const TrustpilotComponent = ({ trustScores, variant = 'trustpilot-container', isP0 }) => {
  return (
    <div className={classNames(styles[variant], { [styles.isP0]: isP0 })}>
      <div className={classNames(styles.flex, { [styles.isP0]: isP0 })}>
        <div className={styles['svg-container']}>
          <TrustpilotLogo />
        </div>
        <img className={styles.trustpilotLogo} src={trustScores.trustpilotImageUrl} alt='trustpilot score' />
      </div>
      <a
        target='_blank'
        href={trustScores.trustpilotUrl}
        className={classNames(styles['review-link'])}
        rel='noreferrer'
      >
        TrustScore {trustScores.trustScore} out of 5 |{' '}
        <span>{trustScores.numberOfReviews.toLocaleString()} reviews</span>
      </a>
    </div>
  )
}
